import { Box, Button, Grid, Theme, Typography, useTheme } from "@mui/material";
import { FrequencyArray, InvestmentFundType } from "../../../redux-store/types/api-types";
import { MandateListItem, MandatesListResBody } from "../../../redux-store/types/investorProfile";
import { useHistory } from "react-router";
import { useState } from "react";
import { MpowerValidationType } from "../types";
import { CustomeBlueDatePicker, CustomeBlueDropDown, CustomeNumberInput, PickUpInput } from "./FromInput";
import AddBankModal from "../common/AddBankModal";
import dayjs from "dayjs";
import { WEEKLYDAYS } from "../../../utils/constant";
import { FormikValues, useFormikContext } from "formik";
import {
    BankDetails, GetOrderEntryBanksListResponseBody
} from "../../../redux-store/types/orderManagement";
import { MandateInfoBox } from "./Mandate";

interface SIPProps {
    isLoading: boolean;
    id: string | number
    // validation: ValidationInvestment
    clientCode?: string
    activeMandateList: Array<MandateListItem>
    data: InvestmentFundType
    valueIdentifier: string
    isSubmitting: boolean;
    bankAccountList?: GetOrderEntryBanksListResponseBody;
    mandatesListRes?: MandatesListResBody;
}

export const handleDateValidation = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs) => {

    if (ArrayOfDate?.length === 0) {
        return false
    }
    if (typeof ArrayOfDate?.[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate?.[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
    }
    return false
}



const LumpsumSIP = (props: SIPProps) => {
    const { isLoading, id, data, clientCode, activeMandateList, valueIdentifier, isSubmitting, bankAccountList, mandatesListRes } = props;
    const { palette } = useTheme();
    const history = useHistory();
    const { validataion: validation, folios, frequencies = [], sipAllowed = "Y", sip } = data
    const { pathname } = history.location

    const { values, setFieldValue } = useFormikContext<FormikValues>();


    const [openBankModal, setOpenBankModal] = useState(false);
    const [isMandateSelectDialogOpen, setMandateSelectDialogOpen] = useState<boolean>(false)



    const getArrayFrequency = data?.frequencies?.filter((item: FrequencyArray) => item?.transactionType === "SIP" && item?.frequency)
    const getValidation = data?.validations?.filter((item: MpowerValidationType) => item?.transactionType === "SIP" && item?.frequency === sip?.periods)[0]

    const minLumpsumAmount = getValidation?.minimumInstallmentAmount ?? 0;

    console.log('array', getArrayFrequency);


    function drowDownDateFormate(array: Array<MandateListItem>) {
        return array?.map((item: MandateListItem) => {
            return {
                label: item?.displayText,
                value: item?.mandateId
            }
        })
    }

    const frequencyArray = data?.frequencies?.filter(item => item.frequency && item.transactionType === 'SIP')
    const Daily = data?.validations?.filter((item) => item?.frequency === 'DAILY' && item?.transactionType === 'SIP')?.[0]
    const Weekly = data?.validations?.filter((item) => item?.frequency === 'WEEKLY' && item?.transactionType === 'SIP')?.[0]
    const WeeklyDays = data?.validations?.filter((item) => item?.frequency === 'WEEKLYDAYS' && item?.transactionType === 'SIP')?.[0]
    const Monthly = data?.validations?.filter((item) => item?.frequency === 'MONTHLY' && item?.transactionType === 'SIP')?.[0]
    const Quarterly = data?.validations?.filter((item) => item?.frequency === 'QUARTERLY' && item?.transactionType === 'SIP')?.[0]
    const Yearly = data?.validations?.filter((item) => item?.frequency === 'YEARLY' && item?.transactionType === 'SIP')?.[0]

    const sipMinAmount = (key = 'minimumInstallmentAmount' as keyof MpowerValidationType, frequency: string) => {

        if (frequency === 'WEEKLY') {
            return Weekly?.[key]
        } else if (frequency === 'MONTHLY') {
            return Monthly?.[key]
        } else if (frequency === 'QUARTERLY') {
            return Quarterly?.[key]
        } else if (frequency === 'YEARLY') {
            return Yearly?.[key]
        } else if (frequency === 'DAILY') {
            return Daily?.[key]
        } else if (frequency === 'WEEKLYDAYS') {
            return WeeklyDays?.[key]
        } else {
            return 0
        }
    }

    const handleOpenMandateSelectDialog = () => {
        setMandateSelectDialogOpen(true)
    }

    const handleCloseMandateSelectDialog = () => {
        setMandateSelectDialogOpen(false)
    }

    const handleMandateSelection = (mandateId: string) => {
        setFieldValue(`fund.${id}.lumpsumSip.mandate`, mandateId)
        setMandateSelectDialogOpen(false)
    }


    return (
        <>
            {/* {(mandatesListRes?.pendingCount ?? 0) === 0 && activeMandateList.length === 0
                &&
                <>
                    <Box m={'auto auto'}>
                        <Typography
                            variant="h6"
                            color={palette.error[500]}
                            sx={{ textAlign: 'center', m: 4 }}
                        >
                            No active mandates are present. Please wait until they are activated.
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            variant="body_500"
                            color={palette.primary[500]}
                            onClick={() => setOpenBankModal(true)}
                            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                        >
                            Create New Mandate
                        </Typography>
                    </Box>
                </>
            }
            {(mandatesListRes?.pendingCount ?? 0) > 0 && activeMandateList.length === 0
                &&
                <>
                    <Box m={'auto auto'}>
                        <Typography
                            variant="h6"
                            color={palette.error[500]}
                            sx={{ textAlign: 'center', m: 4 }}
                        >
                            Please approve the SIP mandate authorization request received from BSE in your email.
                        </Typography>
                    </Box>
                </>
            }
            {(sipAllowed === 'N' || sipAllowed === null) && <>
                <Box m={'auto auto'}>
                    <Typography
                        variant="h6"
                        color={palette.error[500]}
                        sx={{ textAlign: 'center', m: 4 }}
                    >
                        SIP purchase is not allowed.
                    </Typography>
                </Box>
            </>} */}


            <Grid container spacing={2} rowGap={2}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <PickUpInput
                        label='Lumpsum Amount'
                        inputType={'number'}
                        name={`fund[${id}].lumpsumSip.lumpSumAmount`}
                        isLoading={isLoading}
                        disabled={isSubmitting}
                        // value={fund[id]?.lumpsum?.lumpAmount}
                        minValue={minLumpsumAmount}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <PickUpInput
                        disabled={isSubmitting}
                        inputType="number"
                        isLoading={isLoading}
                        name={`fund[${id}].lumpsumSip.sipAmount`}
                        minValue={sipMinAmount('minimumInstallmentAmount', values?.fund[id]?.sip?.periods)}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomeBlueDropDown
                        disabled={isSubmitting}
                        name={`fund[${id}].lumpsumSip.periods`}
                        isLoading={isLoading}
                        label='Frequency'
                        list={[...getArrayFrequency]?.map((item: FrequencyArray) => {
                            return {
                                label: item?.frequency || '',
                                value: item?.frequency || ''
                            }
                        })}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomeNumberInput
                        isLoading={isLoading}
                        disable={isSubmitting}
                        textType="number"
                        label='No. of Installments'
                        name={`fund[${id}].lumpsumSip.installments`}
                        minValue={sipMinAmount('minimumInstallments', values?.fund[id]?.sip?.periods)}
                        minlabel={`Min. ${sipMinAmount('minimumInstallments', values?.fund[id]?.sip?.periods)}`}
                        removeIcons={true}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomeBlueDatePicker
                        name={`fund[${id}].lumpsumSip.sipDate`}
                        isLoading={isLoading}
                        disabled={isSubmitting}
                        disablePast={true}
                        // disableDateList={getValidation?.investmentDates}
                        shouldDisableDate={(date: dayjs.Dayjs) => handleDateValidation(getValidation?.investmentDates, date)}
                        // For T+1 date
                        minDate={dayjs().add(1, 'day')}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    {/* <CustomeBlueDropDown
                        isLoading={isLoading}
                        disabled={isSubmitting}
                        label="Mandate"
                        name={`fund[${id}].sip.mandate`}
                        list={drowDownDateFormate(activeMandateList)}
                    />
                    <Typography
                        component={'a'}
                        variant="subtitle_500"
                        color={palette.primary[500]}
                        onClick={() => setOpenBankModal(true)}
                        style={{ textDecoration: 'underline', cursor: 'pointer' }}
                        fontSize={{ lg: '16px', md: '16px', sm: '14px', xs: '14px' }}
                    >
                        Create New Mandate
                    </Typography> */}
                    {/* <MandateInfoBox
                        isLoading={isLoading}
                        isDisabled={isSubmitting}
                        activeMandateList={activeMandateList}
                        id={id}
                    /> */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: 'center',
                            flexWrap: "wrap"
                        }}
                    >
                        <Button
                            sx={(theme: Theme) => ({
                                ...theme.typography.body_500,
                                color: theme.palette.primary[500],
                                textDecoration: 'underline',
                                padding: 0,
                                ':hover': {
                                    backgroundColor: "transparent"
                                }
                            })}
                            onClick={() => setOpenBankModal(true)}
                            disabled={isSubmitting}
                        >
                            Create New Mandate
                        </Button>
                        <Button
                            sx={(theme: Theme) => ({
                                ...theme.typography.body_500,
                                color: theme.palette.primary[500],
                                textDecoration: 'underline',
                                padding: 0,
                                ':hover': {
                                    backgroundColor: "transparent"
                                }
                            })}
                            onClick={handleOpenMandateSelectDialog}
                            disabled={isSubmitting}
                        >
                            Select Mandate
                        </Button>
                    </Box>
                </Grid>
                {/* {pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' && (
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomeBlueDropDown
                            isLoading={isLoading}
                            disabled={isSubmitting}
                            label="Select Folio"
                            name={`fund[${id}].sip.sipFolio`}
                            list={folios?.availableFolios?.map((item) => ({ label: item, value: item }))}
                        />
                    </Grid>
                )} */}
            </Grid>
            {openBankModal && (
                <AddBankModal
                    {...{
                        handleClose: () => setOpenBankModal(false),
                        open: openBankModal,
                        setOpen: setOpenBankModal,
                        title: 'Add New Bank Mandate',
                        clientCode: clientCode,
                    }}
                />
            )}
        </>
    );
};

export default LumpsumSIP;